<script lang="ts">
  import { Link } from '@inertiajs/svelte'
  import {
    sign_up_path,
    privacy_path,
    terms_path,
    changelog_path,
  } from '@/routes'
  import Layout from '../components/Layout.svelte'
  import Meta from '../components/Meta.svelte'
  import PageContainer from '../components/PageContainer.svelte'
</script>

<Meta />

<Layout showWhatsNewBanner={false}>
  <PageContainer maxWidth="max-w-4xl" paddingY="py-10 sm:py-14">
    <main>
      <article
        class="overflow-hidden rounded-2xl border border-neutral-200 bg-white shadow-sm dark:border-gray-700 dark:bg-gray-800"
      >
        <header
          class="border-b border-neutral-200 bg-primary-50 px-6 py-8 dark:border-gray-700 dark:bg-gray-900 sm:px-10 sm:py-10"
        >
          <p
            class="mb-3 text-xs font-semibold uppercase tracking-[0.18em] text-primary-600 dark:text-primary-300"
          >
            Books, notes, and book clubs
          </p>
          <h1
            class="font-bookshop text-4xl tracking-tight text-neutral-900 dark:text-white sm:text-5xl"
          >
            About Reading Now
          </h1>
          <p
            class="mt-5 max-w-2xl text-lg leading-8 text-neutral-600 dark:text-gray-300"
          >
            A place for the books you read and the people you read with.
          </p>
        </header>

        <div class="space-y-8 px-6 py-8 sm:px-10 sm:py-10">
          <p class="text-base leading-8 text-neutral-600 dark:text-gray-300">
            Reading Now brings your reading list, notes, and conversations into
            one place. Use it to remember a book a friend mentioned, keep track
            of your current read, or find your next book together.
          </p>

          <section aria-labelledby="your-books-heading">
            <h2
              id="your-books-heading"
              class="font-bookshop text-2xl tracking-tight text-neutral-900 dark:text-white"
            >
              Keep your books close
            </h2>
            <p class="mt-3 leading-7 text-neutral-600 dark:text-gray-300">
              Save books for later, track your progress, and look back at what
              you’ve finished. Add ratings and notes, or make a list for the
              books you want to come back to. Whether you read a little each
              night or spend a weekend with a novel, there’s room for your pace.
            </p>
          </section>

          <section aria-labelledby="read-together-heading">
            <h2
              id="read-together-heading"
              class="font-bookshop text-2xl tracking-tight text-neutral-900 dark:text-white"
            >
              Read together
            </h2>
            <p class="mt-3 leading-7 text-neutral-600 dark:text-gray-300">
              Follow friends to see what they’re reading and send a
              recommendation when a book makes you think of them. Book clubs can
              choose their next read, schedule meetings, and keep the discussion
              going between get-togethers.
            </p>
          </section>

          <div class="border-t border-neutral-200 pt-8 dark:border-gray-700">
            <p class="font-bookshop text-2xl text-neutral-900 dark:text-white">
              Start with the book you’re reading now.
            </p>
            <Link
              href={sign_up_path()}
              class="mt-5 inline-flex min-h-11 items-center justify-center rounded-md bg-primary-600 px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-primary-700 focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-primary-600 dark:bg-primary-500 dark:hover:bg-primary-600 dark:focus-visible:outline-primary-300"
            >
              Create an account
            </Link>
          </div>
        </div>
      </article>

      <nav
        aria-label="More about Reading Now"
        class="mt-5 flex flex-wrap gap-x-6 text-sm text-neutral-600 dark:text-gray-400"
      >
        {#each [{ href: changelog_path(), label: 'What’s new' }, { href: privacy_path(), label: 'Privacy' }, { href: terms_path(), label: 'Terms' }] as link (link.href)}
          <Link
            href={link.href}
            class="inline-flex min-h-11 items-center underline-offset-4 hover:underline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-primary-600 dark:focus-visible:outline-primary-300"
            >{link.label}</Link
          >
        {/each}
      </nav>
    </main>
  </PageContainer>
</Layout>
